import baseAPI from '@/http'

const router = 'api/recursosFinanceiros'

export const recursosFinanceirosApi = {
    create: (potencial) => baseAPI.post(router, potencial),
    update: (potencial) => baseAPI.put(router, potencial),
    delete: (id) => baseAPI.delete(`${router}/${id}`),
    list: () => baseAPI.get(router),
    find: (id) => baseAPI.get(`${router}/${id}`),
    getByMunicipio: (municipioId) => baseAPI.get(`${router}/obter-recursos-financeiros-por-municipio/${municipioId}`),
}
